import AppHeader from '@components/AppNavigation/AppHeader';
import EndUsersTable from '@components/Users/EndUsersTable/EndUsersTable';
import React, { FC } from 'react';

const UsersPage: FC = () => (
	<>
		<AppHeader translation="pages.users.title" />
		<EndUsersTable />
	</>
);

export default UsersPage;
